export default {
  title: "Contacten zoeken",
  name: {
    label: "Naam",
    placeholder: "Zoek op contactnaam"
  }
}
